/** Outline button for dark certification backgrounds — not `.btn-secondary` (white fill + dark text). */
export const CERTIFICATION_BTN_OUTLINE_DARK =
  'inline-flex items-center justify-center px-6 py-3 text-sm font-semibold rounded-md border border-white/30 bg-transparent text-white hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black transition-colors font-open-sans disabled:opacity-40 disabled:pointer-events-none'

const paymentUrlTrimmed = String(import.meta.env.VITE_CERTIFICATION_PAYMENT_URL || '').trim()

/** `Purchase access` only when checkout is enabled and a URL is configured. */
export const CERTIFICATION_PAYMENTS_LIVE =
  import.meta.env.VITE_CERTIFICATION_PAYMENTS_ENABLED === 'true' && Boolean(paymentUrlTrimmed)

export const CERTIFICATION_PAYMENT_URL = paymentUrlTrimmed
